import { useSound } from '@/contexts/SoundContext';
import { usePWA } from '@/hooks/usePWA';
import { PixelIcon } from '@/components/ui';
import { useEffect, useState } from 'react';

export function PWAInstallPrompt() {
  const { isInstallable, isInstalled, promptInstall } = usePWA();
  const { playButtonClick } = useSound();
  const [isDismissed, setIsDismissed] = useState(true);

  // Check if prompt was recently dismissed
  useEffect(() => {
    const dismissedUntil = localStorage.getItem('pwa_prompt_dismissed_until');
    if (dismissedUntil) {
      const dismissedDate = new Date(dismissedUntil);
      const now = new Date();
      if (now < dismissedDate) {
        setIsDismissed(true);
      } else {
        setIsDismissed(false);
      }
    }
  }, []);

  if (!isInstallable || isInstalled || isDismissed) {
    return null;
  }

  const handleInstall = async () => {
    playButtonClick();
    const success = await promptInstall();
    if (!success) {
      setIsDismissed(true);
    }
  };

  const handleDismiss = () => {
    playButtonClick();
    setIsDismissed(true);

    // Hide for 1 week (7 days)
    const dismissUntil = new Date();
    dismissUntil.setDate(dismissUntil.getDate() + 7);
    localStorage.setItem('pwa_prompt_dismissed_until', dismissUntil.toISOString());
  };

  return (
    <div className="pwa-install-prompt">
      <div className="install-content">
        <div className="install-icon">
          <PixelIcon name="mobile" size={24} color="#3498db" />
        </div>
        <div className="flex flex-col md:flex-row flex-wrap gap-4 ml-2 w-full">
          <div className="install-text">
            <h3>Install Take Me Home</h3>
            <p>Get the full experience with our app!</p>
          </div>
          <div className="install-actions">
            <button onClick={handleInstall} className="btn-primary btn-small">
              Install
            </button>
            <button onClick={handleDismiss} className="btn-secondary btn-small">
              Not Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PWAInstallPrompt;
